export default __webpack_public_path__ + "static/v2_lucian_bw-5b69311410ad2870bec6084b61aa259e.jpg";